import { module } from 'modujs';

export default class extends module {

    constructor(m) {
        super(m);
        this.events = { click: { open: 'open', close : 'close' } };
        this.content = this.$( 'content')[0];

        this.forms = [...this.content.querySelectorAll( '[data-module-ajax-form]' )];
        this.forms.forEach( form => form.addEventListener( 'response', response =>{
            if( response.detail.success ){
                setTimeout( () => {
                    form.classList.remove( 'success' );
                    this.call( 'update', 'Scroll' );
                    this.close();
                }, 3000);
            }
        } ) );
        this.$('close').forEach( el => el.addEventListener( 'click', this.close.bind( this ) ) );
    }

    open(){
        this.call( 'open', this.content, 'ModalPreview' );
    }

    close(){

        this.call( 'close', false, 'ModalPreview' );
    }

}
